import { put, call, takeLatest } from 'redux-saga/effects'
import {  dashboardLoaderAC } from '../system/systemActionCreators'
import {
    addTicketResponse,
    addTicketsItem,
    changeTicketsItem, getMerchantData,
    getTicketsList, viewedTicketResponse
} from 'model/dashboardTickets/dTicketsAPI';
import {
    dTicketsAddResponseItemSagaAC,

    dTicketsEditItemSagaAC, dTicketsMerchantDataLoaderAC,
    dTicketsSetDataAC,
    dTicketsSetDataSagaAC,
    dTicketsSetDetailItemAC,
    dTicketsSetMerchantDataAC,
    dTicketsSetMerchantDataSagaAC,
    dTicketsSetResponseViewedItemSagaAC
} from 'model/dashboardTickets/dTicketsActionCreators';
import {
    IdTicketsStateDataItem,
     typeTicketResponse,
    typeTicketsFilters
} from "model/dashboardTickets/dTicketsReducer";
import { dTicketsAddItemSagaAC } from "model/dashboardTickets/dTicketsActionCreators";
import { errorGenerator, notificationCreator } from 'model/system/utils';


// Temp data list mapper
const tempDataMapper = ( tempResponseData: any ): IdTicketsStateDataItem[] => {
    return tempResponseData.map(( item: IdTicketsStateDataItem ) => {
        return (
            {
                name: item.name,
                description: item.description,
                id: item.id,
                responses: item.responses,
                status: item.status,
                userCreated: item.userCreated,
                dateCreated: item.dateCreated,
                dateUpdated: item.dateUpdated,
                viewedByCreator: item.viewedByCreator,
                viewedBySupport: item.viewedBySupport
            }
        )
    })
}

// Get data function-generator
function* getData( payload: { filters: typeTicketsFilters } ) {

    let response = yield call(getTicketsList, payload)

    if (response.status === 200) {

        const tempData: IdTicketsStateDataItem[] = tempDataMapper(response.data)

        yield put(dTicketsSetDataAC(tempData))

    } else {
        yield errorGenerator(response)
    }
}

// ---------------------------------------------------------------------------------------------------------------------
// Saga set data
export function* dTicketsSetDataWorker(
    actionObject: {
        type: string,
        payload: {
            token: string,
            refreshToken: string,
            filters: typeTicketsFilters
        }
    }
) {

    yield put(dashboardLoaderAC(true))

    yield getData(actionObject.payload)

    yield put(dashboardLoaderAC(false))

}

export function* dTicketsSetDataWatcher() {
    yield takeLatest(dTicketsSetDataSagaAC.type, dTicketsSetDataWorker)
}

// ---------------------------------------------------------------------------------------------------------------------
// Saga add data item
export function* dTicketsAddItemWorker( actionObject: {
    type: string,
    payload: {
        itemObject: { name: string, description: string, status: string },
        filters: typeTicketsFilters
    }
} ) {

    yield put(dashboardLoaderAC(true))

    let response = yield call(addTicketsItem, { dataObject: actionObject.payload.itemObject })

    if (response.status === 200) {

        yield notificationCreator('SUCCESS_ADD_ITEM')
        yield getData({ filters: actionObject.payload.filters, })

    } else {
        yield errorGenerator(response)
    }
    yield put(dashboardLoaderAC(false))
}

export function* dTicketsAddDataWatcher() {
    yield takeLatest(dTicketsAddItemSagaAC.type, dTicketsAddItemWorker)
}

// ---------------------------------------------------------------------------------------------------------------------
// // Saga edit data item
export function* dTicketsEditDataItemWorker(
    actionObject: {
        type: string,
        payload: {
            detailItemObject: IdTicketsStateDataItem,
            filters: typeTicketsFilters
        }
    }
) {

    yield put(dashboardLoaderAC(true))

    let response = yield call(changeTicketsItem, {dataObject: actionObject.payload.detailItemObject })

    if (response.status === 200) {
       yield notificationCreator('SUCCESS_CHANGE_ITEM')

        yield getData({ filters: actionObject.payload.filters, })

        if (actionObject.payload.detailItemObject.responses) {
          yield put(dTicketsSetDetailItemAC(actionObject.payload.detailItemObject.id))
        }
    } else {
        yield errorGenerator(response)
    }

    yield put(dashboardLoaderAC(false))

}

export function* dTicketsEditDataWatcher() {
    yield takeLatest(dTicketsEditItemSagaAC.type, dTicketsEditDataItemWorker)
}

// ---------------------------------------------------------------------------------------------------------------------
// // Saga add response to ticket
export function* dTicketsAddResponseDataItemWorker(
    actionObject: {
        type: string,
        payload: {
            detailItemObject: typeTicketResponse,
            filters: typeTicketsFilters
        }
    }
) {

    yield put(dashboardLoaderAC(true))

    let response = yield call(addTicketResponse, {dataObject: actionObject.payload.detailItemObject })

    if (response.status === 200) {

        yield getData({ filters: actionObject.payload.filters, })

        yield put(dTicketsSetDetailItemAC(actionObject.payload.detailItemObject.id!))
    } else {
        yield errorGenerator(response)
    }

    yield put(dashboardLoaderAC(false))

}

export function* dTicketsAddResponseDataWatcher() {
    yield takeLatest(dTicketsAddResponseItemSagaAC.type, dTicketsAddResponseDataItemWorker)
}

// ---------------------------------------------------------------------------------------------------------------------
// // Saga set response viewed
export function* dTicketsSetResponseViewedItemWorker(
    actionObject: {
        type: string,
        payload: {
            detailItemObject: typeTicketResponse,
            filters: typeTicketsFilters
        }
    }
) {

    yield put(dashboardLoaderAC(true))


    let response = yield call(viewedTicketResponse, { dataObject: actionObject.payload.detailItemObject })

    if (response.status === 200) {

        yield getData({ filters: actionObject.payload.filters, })

    } else {
        yield errorGenerator(response)
    }

    yield put(dashboardLoaderAC(false))

}

export function* dTicketsSetResponseViewedWatcher() {
    yield takeLatest(dTicketsSetResponseViewedItemSagaAC.type, dTicketsSetResponseViewedItemWorker)
}
//
// // ---------------------------------------------------------------------------------------------------------------------

export function* dTicketsSetMerchantDataWorker(
    actionObject: {
        type: string,
        payload: { merchantId: string, }
    }
) {
    yield put(dTicketsMerchantDataLoaderAC(true))
    let response = yield call(getMerchantData, actionObject.payload.merchantId)

    if (response.status === 200) {
        yield put(dTicketsSetMerchantDataAC(response.data))

    } else {
        yield errorGenerator(response)
    }
    yield put(dTicketsMerchantDataLoaderAC(false))
}

export function* dTicketsSetMerchantDataWatcher() {
    yield takeLatest(dTicketsSetMerchantDataSagaAC.type, dTicketsSetMerchantDataWorker)}
